import { render, staticRenderFns } from "./FlowPaymentInfoApprovalsView.vue?vue&type=template&id=f0205a40&scoped=true&"
import script from "./FlowPaymentInfoApprovalsView.vue?vue&type=script&lang=ts&"
export * from "./FlowPaymentInfoApprovalsView.vue?vue&type=script&lang=ts&"
import style0 from "./FlowPaymentInfoApprovalsView.vue?vue&type=style&index=0&id=f0205a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0205a40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow})
